export const powerPlanSolutionFields = [
    {
        key: "name",
        label: "Name",
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];
